// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import { Text, Heading } from '@nerdwallet/react-typography';
import Step from './step';
import Row from '../row/row';
import VerticalSpacer from '../vertical-spacer/vertical-spacer';

import parseMdLinks from '../../lib/parse-md-links';

import './three-steps.less';

const ThreeSteps = ({
  anchorId,
  backgroundColor,
  steps,
  className,
  title,
  subtitle,
  titleLevel,
  button,
}) => {
  const ctaButton = button && (
    <div className="three-steps__button">
      <VerticalSpacer mobile="p-24" tablet="p-24" desktop="p-24" />
      {button}
    </div>
  );

  return (
    <Row
      className={classnames('three-steps', className)}
      backgroundColor={backgroundColor}
      id={anchorId}
    >
      <VerticalSpacer desktop="p-60" tablet="p-60" mobile="p-60" />
      {title && (
        <Heading
          className="three-steps__title centered-in-parent"
          level={titleLevel}
        >
          {title}
        </Heading>
      )}
      {subtitle && (
        <VerticalSpacer desktop="p-18" tablet="p-18" mobile="p-18" />
      )}
      {subtitle && (
        <Text className="three-steps__subtitle centered-in-parent" small>
          {parseMdLinks(subtitle)}
        </Text>
      )}
      {title && <VerticalSpacer desktop="p-30" tablet="p-30" />}
      <div className="three-steps__steps nw-row">
        {steps.map((step) => (
          <Step key={step.name} {...step} />
        ))}
      </div>
      {ctaButton}
      <VerticalSpacer desktop="p-60" tablet="p-60" mobile="p-60" />
    </Row>
  );
};

ThreeSteps.propTypes = {
  anchorId: PropTypes.string,
  backgroundColor: PropTypes.string,
  steps: PropTypes.array,
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  titleLevel: PropTypes.string,
  button: PropTypes.element,
};

ThreeSteps.defaultProps = {
  steps: [],
  className: '',
  titleLevel: '2',
};

export default ThreeSteps;
